module.exports = __webpack_public_path__ + "static/img/8.a63d3f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/GoodsShow/AirPods Pro/imgs/first/8.jpg
// module id = K+eX
// module chunks = 0